import React from 'react';
import { DrawerProps } from '@cad-arc';
import { HoldEventDrawer } from '../../hold-event/hold-event-drawer';
import { EditTemporaryUnitDrawer } from '../../log-on-edit-unit/edit-temporary-unit-drawer';
import { LogOnEditUnitDrawer } from '../../log-on-edit-unit/log-on-edit-unit-drawer';
import { AdminStatusDrawer } from '../../unit-status/drawers/admin-status-drawer';
import { UnitLocationDrawer } from '../../unit-location/unit-location-drawer';
import { DirectedPatrolDrawer } from '../../unit-status/drawers/directed-patrol-drawer';
import { SpecialAssignmentDrawer } from '../../unit-status/drawers/special-assignment-drawer';
import { TransportDrawer } from '../../unit-status/drawers/transport-drawer';
import { VirtualPatrolDrawer } from '../../unit-status/drawers/virtual-patrol-drawer';
import { ManageUnitsDrawerHost } from '../../manage-units/manage-units-drawer-host';
import { useDrawerControls, useDrawerRender } from './drawer-context-provider';
import { ErrorBoundary } from '../../monitoring/error-boundary';
import { ServiceRotationDrawer } from '../../service-rotation/service-rotation-drawer';
import { EditHospitalDrawer } from '../../edit-hospital-drawer/edit-hospital-drawer';
import { FrEventSubjectDataDrawer } from '../../fr-event-subject-data-drawer/fr-event-subject-data-drawer';
import { FrUnitStatusDrawer } from '../../fr-unit-status-drawer/fr-unit-status-drawer';
import { WrappedFrMessagingDrawer as FrMessagingDrawer } from '../../fr-messaging-drawer/fr-messaging-drawer';
import { FrExportDrawer } from '../../export-list-drawer/export-list-drawer';
import { FrUnitsListDrawer } from '../../fr-units-list/fr-units-list-drawer/fr-units-list-drawer';
import { MasterProfileMatchesDrawer } from '../../master-profile-matches-drawer/master-profile-matches-drawer';
import { SensorEventsDrawer } from '../../sensors/sensor-events-drawer';

export const drawerComponents = {
    'manage-units': ManageUnitsDrawerHost,
    'log-on-edit-unit': LogOnEditUnitDrawer,
    'edit-temporary-unit': EditTemporaryUnitDrawer,
    'status-admin': AdminStatusDrawer,
    'status-directed-patrol': DirectedPatrolDrawer,
    'status-virtual-patrol': VirtualPatrolDrawer,
    'status-special-assignment': SpecialAssignmentDrawer,
    'status-transport': TransportDrawer,
    'hold-event': HoldEventDrawer,
    'unit-location': UnitLocationDrawer,
    'service-rotation': ServiceRotationDrawer,
    'edit-hospital': EditHospitalDrawer,
    'fr-unit-status': FrUnitStatusDrawer,
    'fr-messaging': FrMessagingDrawer,
    'fr-event-subject-data': FrEventSubjectDataDrawer,
    export: FrExportDrawer,
    'fr-units-list': FrUnitsListDrawer,
    'master-profile-matches': MasterProfileMatchesDrawer,
    'sensor-events': SensorEventsDrawer,
} as const;

export type DrawerComponents = typeof drawerComponents;
export type DrawerNames = keyof DrawerComponents;

export function DrawerRenderer({
    portalProps,
}: {
    portalProps?: DrawerProps['portalProps'];
}): JSX.Element | null {
    const drawerState = useDrawerRender();
    const drawerControls = useDrawerControls();

    if (!drawerState || !drawerState.drawer) {
        return null;
    }

    const ComponentType = drawerComponents[drawerState.drawer.type];

    return (
        <ErrorBoundary
            name="DRAWER"
            messageVerbNoun="opening a panel"
            extraTags={{ drawerType: drawerState.drawer.type }}
            asToast={true}
            onError={() => {
                drawerControls.close();
            }}
        >
            {/* @ts-expect-error complains about props */}
            <ComponentType
                {...drawerState.drawer.props}
                portalProps={portalProps}
                key={drawerState.key}
            />
        </ErrorBoundary>
    );
}
